export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "CHIPS_jpgcover";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			const vidIcons = document.querySelectorAll(".jpg-cover");
			this.$el.querySelector("img").addEventListener("click", (e) => {
				e.preventDefault();
				const iframe = this.$el.querySelector("iframe");
				let src = iframe.getAttribute("src");
				if (src && src.includes("vimeo")) {
					this.$el.parentElement.classList.add("video-on");
					const videoEl =
						this.$el.parentElement.querySelector("iframe");
					videoEl.contentWindow.postMessage(
						'{"method":"play"}',
						"https://player.vimeo.com"
					);
					videoEl.contentWindow.postMessage(
						'{"event":"command","func":"playVideo","args":""}',
						"*"
					);
				} else {
					if (iframe) {
						let src = iframe.getAttribute("data-src");
						this.$el.parentElement.classList.add("video-on");
						if (src.includes("vimeo")) {
							src = src.replace("?", "?autoplay=1&");
						} else {
							src = src.replace(
								'feature=oembed"',
								'feature=oembed&autoplay=1"'
							);
						}
						iframe.setAttribute(
							"sandbox",
							"allow-same-origin allow-scripts allow-popups"
						);
						iframe.setAttribute("data-src", null);
						iframe.setAttribute("src", src);

						// const parent = iframe.parentNode;
						// const next = iframe.nextSibling;
						// parent.removeChild(iframe);
						// parent.insertBefore(iframe, next);

						if (src.includes("vimeo")) {
							iframe.onload = function () {
								const videoEl = iframe;
								videoEl.contentWindow.postMessage(
									'{"method":"play"}',
									"https://player.vimeo.com"
								);
								videoEl.contentWindow.postMessage(
									'{"event":"command","func":"playVideo","args":""}',
									"*"
								);
								// const player = new Vimeo.Player(iframe);
								// player.play().catch((error) => {
								// 	console.warn("Autoplay failed:", error);
								// });
							};
						}
					}
				}
			});
		}
	}
}
